<template>
  <div>
    <px-view-header title="Alçadas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <listagem-configuracao-aprovacao-header :on-click-refresh="onClickRefresh"
                                            :on-change-filter="onChangeFilter"/>
    <lista-configuracao-aprovacao :configuracoes="configuracoes" :loading="loading"
                                  :on-change-options="onChangeOptions"
                                  :options-list="optionsList"
                                  @update="onClickRefresh"/>
  </div>
</template>

<script>
import ListagemConfiguracaoAprovacaoHeader
  from '@/modules/configuracao-aprovacao/ListagemConfiguracaoAprovacaoHeader.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaConfiguracaoAprovacao
  from '@/modules/configuracao-aprovacao/ListaConfiguracaoAprovacao.vue';
import ConfiguracaoAprovacaoService from './configuracao-aprovacao-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      configuracoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
      breadcrumbs: [
        { text: 'Configurações' },
        { text: 'Alçadas' },
      ],
    };
  },
  methods: {
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getConfiguracoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getConfiguracoes();
    },
    onClickRefresh() {
      this.getConfiguracoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getConfiguracoes() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return ConfiguracaoAprovacaoService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.configuracoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: { ListagemConfiguracaoAprovacaoHeader, ListaConfiguracaoAprovacao },
};

</script>
